// German

const lang = {
  gateMediaPreviewHeader: 'Könnte dir auch gefallen',
  loadmore: 'Mehr anzeigen',
  nextMedia: 'Nächstes Medien',
  previousMedia: 'Vorherige Medien',
  closePost: 'Beitrag schließen',
  nextPost: 'Nächster Beitrag',
  previousPost: 'Vorherig Beitrag',
  outOfStock: 'Ausverkauft',
  numberOfReviews(n) {
    return n === 1 ? 'Rezension' : 'Rezensionen'
  },
  reportFormField: 'Bitte geben Sie eine Nachricht ein',
  reportPost: 'Beitrag Melden',
  reportFormTitle: 'Möchten Sie dieses Bild melden?',
  reportFormDetails:
    'Wenn Sie der Meinung sind, dass das Bild unangemessen oder illegal ist oder die Rechte einer Person verletzt, können Sie den Inhalt melden. Wenn Sie das Bild / den Text melden, werden die Moderatoren benachrichtigt und die entsprechenden Massnahmen ergriffen.',
  reportFormMessagePlaceholder: 'Geben Sie den Grund Ihres Berichts an',
  reportFormMessageLabel: 'Nachricht',
  reportFormEmailLabel: 'Ihre Email',
  reportFormSubmitButtonText: 'Nachricht senden',
  reportFormCancelButtonText: 'Abbrechen',
  reportFormSentTitle: 'Vielen Dank für Ihre Nachricht!',
  reportFormSentCloseButtonText: 'Schließen',
  cardAndTileAriaLabel: 'Liste mit Beiträgen von Konten in diversen sozialen Medien',
  carouselAriaLabel: 'Karussell mit Beiträgen von Konten in diversen sozialen Medien',
  singleAriaLabel: 'Unten finden Sie einen Beitrag von einem Social-Media-Konto',
  poweredBy: 'Betrieben von Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` veröffentlicht am ${date}` : ''
    const createdByString = userName ? ` von ${userName}` : ''
    return `Foto${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Laden Sie Ihre Medien hoch',
  openTheGate: 'Öffnen Sie den Dialog',
  gridRoleDescription: 'Karussell',
  carouselRoleDescription: 'Raster',
  tiktokVideoAriaLabel:
    'Eingebettetes TikTok-Video. Drücke auf Abspielen, um den Inhalt anzusehen.',
  feedThumbnailAriaLabel: (postIndex, maxPosts) =>
    `Medienvorschau ${postIndex + 1} von ${maxPosts}, öffnet einen Dialog mit Inhalten aus sozialen Netzwerken und einer Produktliste.`,
  carouselControlButtonsAriaLabel: 'Steuerungstasten des Karussells',
  gateCarouselIndicatorAriaLabel: (mediaIndex, maxMedia) =>
    `Medium ${mediaIndex + 1} von ${maxMedia}`,
  showMoreCaption: 'Mehr Beschreibung anzeigen',
  showLessCaption: 'Weniger Beschreibung anzeigen',
  originalPrice: (price) => `Originalpreis: ${price}`,
  salesPrice: (price) => `Angebotspreis: ${price}`,
  postPublishedBy: 'Beitrag veröffentlicht von',
  mediaAltText: (isVideo, username, date, altText) => {
    const mediaType = isVideo ? 'Video' : 'Bild'
    const user = username ? `${username}` : 'unbekannter Benutzer'
    const publishDate = date ? `am ${date}` : ''
    return `${mediaType} gepostet von ${user} ${publishDate}. Es kann ${altText} sein`
  },
  gateSlideAriaLabel: (postIndex, maxPosts) => `Beitrag ${postIndex + 1} von ${maxPosts}.`,
}

export default lang
